import Vue from "vue";
import App from "./App.vue";

// 引入vue-router
import VueRouter from "vue-router";
Vue.use(VueRouter);

// 引入Elementui
// 后台只剩 OPC 控制台一个页面，只用 element-ui。
// 原先还全局注册了 vant / vue-esign / echarts / qs，它们只有已删除的旧页面在用，
// 注册了却无人引用的部分会照旧打进 vendor 包 —— 已一并移除。
// 包名仍留在 package.json 的 dependencies 里，未做 npm 层清理。
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import router from "./router";
import store from "./store/index";

// 引入http
import http from "./utils/request";
Vue.prototype.$http = http;

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
